import { render, staticRenderFns } from "./ReviewAverageOnlineRating.vue?vue&type=template&id=7be07858"
import script from "./ReviewAverageOnlineRating.vue?vue&type=script&lang=js"
export * from "./ReviewAverageOnlineRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports